import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import tinycolor from 'tinycolor2';
import palette from '../foundational-styles/palette';

var getTooltipProps = function getTooltipProps(appearance) {
  switch (appearance) {
    case 'card':
      return {
        backgroundColor: 'white',
        elevation: 3
      };

    case 'default':
    default:
      return {
        color: 'white',
        backgroundColor: tinycolor(palette.neutral.base).setAlpha(0.95).toString()
      };
  }
};

export default getTooltipProps;